import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator/paginator.component';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorIntlRu } from './mat-paginator-intl-ru';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
    declarations: [PaginatorComponent],
    imports: [CommonModule, MatPaginatorModule],
    exports: [PaginatorComponent],
    providers: [
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlRu },
        { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    ],
})
export class PaginatorModule {}
